export default __webpack_public_path__ + "5fdb354.png";